import type { APIClient } from '@src/shared/api';
import settings from '@src/shared/config';

import { useMutation } from '@src/shared/query';

const changePasswordUrl = `${settings.AUTH.JWT.AUTH_DOMAIN}/api/v1/auth/password/change/`;

export type PasswordChangePayload = {
  password: string;
  otp_code: string;
};

type PasswordChangeResponse = {
  detail: string;
};

export function usePasswordChange() {
  return useMutation<PasswordChangeResponse, Error, PasswordChangePayload>({
    mutationKey: ['auth', 'password-change'],
    mutateFn: ({
      apiClient,
      ...payload
    }: { apiClient: APIClient } & Record<string, unknown>) => {
      return apiClient.request({
        url: changePasswordUrl,
        method: 'POST',
        payload,
      }) as Promise<PasswordChangeResponse>;
    },
  });
}
